(function () {
  angular.module('calendarApp').directive('packageInfoPopover', ["$filter", function ($filter) {
    return {
      restrict: 'A',
      scope: {
        package: '='
      },
      replace: false,
      link: function link(scope, elem, attrs) {
        var $packageInfo = $('<div>').addClass('package-info-popover'),
            $description = $('<p>').addClass('package-popover-description').text(scope.package.description);
        $packageInfo.append($description);
        var $expiry;

        if (scope.package.expirytype == 'date') {
          var packageText = $filter('calendarLabel')('package expires on');
          packageText += ' ' + $filter('smoothDate')(scope.package.expirydate, smooth.timeSettings);
          $expiry = $('<p>').addClass('package-popover-expiry').text(packageText);
          $packageInfo.append($expiry);
        } else if (scope.package.expirytype == 'days') {
          var text1 = $filter('calendarLabel')('package expires'),
              text2 = $filter('calendarLabel')('days after purchase'),
              expiryText = text1 + ' ' + scope.package.expirydays + ' ' + text2;
          $expiry = $('<p>').addClass('package-popover-expiry').text(expiryText);
          $packageInfo.append($expiry);
        }

        if (scope.package.requirescoupon) {
          var text3 = $filter('calendarLabel')('requires a coupon code');
          $coupon = $('<p>').addClass('package-popover-expiry').text(text3);
          $packageInfo.append($coupon);
        }

        $(elem).popover({
          'content': $packageInfo,
          'placement': 'auto',
          'html': true,
          'trigger': 'hover'
        });
      }
    };
  }]); // End directive
})();